import { Divider, IconButton } from "@mui/material";
import { Close, Search, TaskAlt } from "@mui/icons-material";
import { useCallback, useEffect, useMemo, useState } from "react";

import Box from "../../Box";
import Avatar from "../../Avatar";
import Button from "../../Button";
import FormField from "../../FormField";
import Typography from "../../Typography";
import Helpers from "../../../commons/helpers";
import useStrings from "../../../hooks/useStrings";
import Resources from "../../../constants/resources";
import ControlLabelCheckBox from "../../ControlLabelCheckBox";
import OrganizationService from "../../../services/identity/organization.service";
import ServiceOrganizationService from "../../../services/identity/serviceOrganization.service";

import { ItemType, addNewItem, itemBox } from "../styles";
import { IOwnerOrganization } from "../../../commons/interfaces";
import { ServiceOrganizationAction } from "../../../constants/enums";
import { useCommonComponentContext } from "../../../providers/CommonComponentProvider";

interface IProps {
    onClose: () => void;
    getUserLoginInformation: () => void;
    onSubmit: (currentStep: number, addOrganizationIds: string[]) => void;
}

interface ISelectedOrganization {
    id: string;
    action: ServiceOrganizationAction;
}

let CURRENT_ORGANZATION: ISelectedOrganization[] = [];

const AddOrganizationStep: React.FC<IProps> = ({ onClose, onSubmit, getUserLoginInformation, ...props }: IProps) => {
    const strings = useStrings();
    const { onError, onHideLoading, onShowLoading, clientId } = useCommonComponentContext();
    const [search, setSearch] = useState<string>("");
    const [checked, setChecked] = useState<boolean>(false);
    const [selected, setSelected] = useState<ISelectedOrganization[]>([]);
    const [data, setData] = useState<IOwnerOrganization[]>([]);

    const onSearch = () => { };

    useEffect(() => {
        const getData = async () => {
            CURRENT_ORGANZATION = [];
            const result = await OrganizationService.getOwnedOrganization({ exceptCurrentService: true });
            const selectedServices: ISelectedOrganization[] = [];
            result.map((item) => {
                if (item.existsOnService) {
                    selectedServices.push({
                        id: item.id,
                        action: ServiceOrganizationAction.Update,
                    });
                    CURRENT_ORGANZATION.push({
                        id: item.id,
                        action: ServiceOrganizationAction.Update,
                    });
                }
            });
            setData(result);
            setSelected(selectedServices);
        };
        getData();
    }, []);

    const handleSelectItem = (id: string) => {
        let selectedTemp = [...selected];
        let index = selectedTemp.findIndex((item) => item.id === id);

        if (index !== -1) {
            selectedTemp[index].action =
                selectedTemp[index].action === ServiceOrganizationAction.Delete ? ServiceOrganizationAction.Create : ServiceOrganizationAction.Delete;
            setSelected(selectedTemp);
        } else {
            setSelected((prev) => [
                ...prev,
                {
                    id: id,
                    action: ServiceOrganizationAction.Create,
                },
            ]);
        }
    };

    const handleChecked = (value: boolean) => {
        setChecked(value);
        setSelected(
            value === true
                ? filteredData.map((item) => ({
                    id: item.id,
                    action: ServiceOrganizationAction.Create,
                }))
                : []
        );
    };

    const handleAddNewItem = async () => {
        // let newItem: IOwnerOrganization = {
        //     tenantCode: "000000",
        //     organizationCode: "00018B",
        //     type: 0,
        //     name: {
        //         value: {
        //             vi: search,
        //             en: "",
        //         },
        //     },
        //     description: {
        //         value: {
        //             vi: search,
        //             en: "",
        //         },
        //     },
        //     gene: "0018B",
        //     logoId: "476588966913503232",
        //     logoUrl: "",
        //     searchText: "maysoft",
        //     id: String(moment().unix()),
        //     status: 1,
        //     createTime: "1691464468",
        //     createUser: "464713852743696384",
        //     updateTime: "1691464468",
        //     updateUser: "464713852743696384",
        // };
        // setData(prev => [...prev, newItem]);
        // setSelected(prev => [...prev, newItem.id]);
    };

    const renderItem = useCallback(
        (item: IOwnerOrganization) => {
            let isSelected = selected
                .filter((item) => item.action !== ServiceOrganizationAction.Delete)
                .map((el) => el.id)
                .includes(item.id);
            return (
                <Box
                    key={item.id}
                    sx={(theme) => itemBox(theme, { isSelected, type: ItemType.Organization })}
                    onClick={() => handleSelectItem(item.id)}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: 0,
                            right: 5,
                        }}
                    >
                        {isSelected && <TaskAlt color="info" sx={{ fontSize: "1rem" }} />}
                    </Box>
                    <Avatar
                        size="sm"
                        src={item.logoUrl}
                        style={{ border: "1px #c3c3c3 solid" }}
                        text={Helpers.getMultiContentLanguage(item.name)}
                    />
                    <Box sx={{ width: "100%", height: 40 }}>
                        <Divider sx={{ my: 1 }} />
                        <Typography
                            sx={{
                                display: "-webkit-box",
                                overflow: "hidden",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                            }}
                        >
                            {Helpers.getMultiContentLanguage(item.name)}
                        </Typography>
                    </Box>
                </Box>
            );
        },
        [handleSelectItem]
    );

    const filteredData = useMemo(
        () => (search ? data.filter((item) => Helpers.getMultiContentLanguage(item.name).includes(search)) || [] : data),
        [search, data]
    );

    const onAction = async () => {
        try {
            if (selected.length === 0) {
                onError(strings.Common.PLEASE_SELECT_AN_ORGANIZATION);

                return;
            }
            onShowLoading();
            const currentIds = CURRENT_ORGANZATION.map((el) => el.id);
            let organizations: any[] = [];
            selected.map((item) => {
                if (
                    !currentIds.includes(item.id) &&
                    (item.action === ServiceOrganizationAction.Update || item.action === ServiceOrganizationAction.Create)
                ) {
                    organizations.push({
                        organizationId: item.id,
                        action: item.action,
                    });
                }
                if (
                    currentIds.includes(item.id) &&
                    (item.action === ServiceOrganizationAction.Create || item.action === ServiceOrganizationAction.Update)
                ) {
                    organizations.push({
                        organizationId: item.id,
                        action: ServiceOrganizationAction.Update,
                    });
                }
                if (currentIds.includes(item.id) && item.action === ServiceOrganizationAction.Delete) {
                    organizations.push({
                        organizationId: item.id,
                        action: item.action,
                    });
                }
            });
            let data = {
                organizations: organizations,
                clientId: clientId,
            };
            const result = await ServiceOrganizationService.add(data);
            await getUserLoginInformation();
            await onSubmit(0, result);
        } catch (error: any) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            onHideLoading();
        }
    };

    return (
        <>
            <Box sx={{ height: 404, overflowY: "scroll" }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "flex-end",
                    }}
                >
                    <FormField
                        fullWidth
                        size="small"
                        defaultValue={search || ""}
                        placeholder={`${strings.Common.SEARCH}...`}
                        onBlur={(value: any) => setSearch(value)}
                        onKeyPress={(e: any) => {
                            if (e.key === "Enter") {
                                setSearch(e.target.value);
                            }
                        }}
                        InputProps={{
                            startAdornment: (
                                <IconButton color="info" onClick={() => onSearch()}>
                                    <Search />
                                </IconButton>
                            ),
                            endAdornment: search && (
                                <IconButton
                                    color="secondary"
                                    onClick={() => {
                                        setSearch(undefined);
                                    }}
                                >
                                    <Close />
                                </IconButton>
                            ),
                        }}
                    />
                    <ControlLabelCheckBox value={checked} onChangeValue={(value) => handleChecked(value)} label={strings.Common.ALL} />
                </Box>
                <Box
                    sx={{
                        mt: 1,
                        display: "grid",
                        gap: "0.5rem",
                        gridTemplateColumns: {
                            xs: "repeat(2, 1fr)",
                            sm: "repeat(3, 1fr)",
                            md: "repeat(4, 1fr)",
                        },
                        overflowY: "scroll",
                    }}
                >
                    {filteredData.map(renderItem)}
                </Box>
                {filteredData.length === 0 && (
                    <Box sx={addNewItem} onClick={handleAddNewItem}>
                        <Typography>{strings.Common.NO_DATA}</Typography>
                    </Box>
                )}
                {/* <Box sx={addNewItem} onClick={handleAddNewItem}>
                     <Typography>
                         {strings.SERVICE_ORGANIZATION.ADD_NEW_ORGANIZATION}: <strong>{search}</strong>
                     </Typography>
                     <AddCircleOutline />
                 </Box> */}
            </Box>
            <Box display="flex" justifyContent="flex-end" alignItems="flex-end" my={0.5}>
                <Button color="secondary" style={{ marginRight: 5 }} onClick={onClose}>
                    {strings.Common.CLOSE}
                </Button>

                <Button onClick={onAction}>{strings.Common.CONTINUE}</Button>
            </Box>
        </>
    );
};

export default AddOrganizationStep;
